export type KVOrientationVector = {
  x: number
  y: number
  z: number
}

export type KVOrientationAxesJSON = {
  orientationVector: KVOrientationVector
  orientationNameFront: string
  orientationNameBack: string
  orientationNameLeft: string
  orientationNameRight: string
  orientationNameUp: string
  orientationNameDown: string
}

export class KVOrientationAxes {
  orientationVector: KVOrientationVector
  orientationNameFront: string
  orientationNameBack: string
  orientationNameLeft: string
  orientationNameRight: string
  orientationNameUp: string
  orientationNameDown: string

  constructor() {
    this.orientationVector = { x: 0, y: 0, z: 0 }
    this.orientationNameFront = 'FRNT'
    this.orientationNameBack = 'BACK'
    this.orientationNameLeft = 'LEFT'
    this.orientationNameRight = 'RGHT'
    this.orientationNameUp = 'UP'
    this.orientationNameDown = 'DOWN'
  }

  static fromJSON(json: KVOrientationAxesJSON): KVOrientationAxes {
    const axes = new KVOrientationAxes()
    axes.orientationVector = json.orientationVector
    axes.orientationNameFront = json.orientationNameFront
    axes.orientationNameBack = json.orientationNameBack
    axes.orientationNameLeft = json.orientationNameLeft
    axes.orientationNameRight = json.orientationNameRight
    axes.orientationNameUp = json.orientationNameUp
    axes.orientationNameDown = json.orientationNameDown
    return axes
  }

  static toJSON(axes: KVOrientationAxes): KVOrientationAxesJSON {
    return {
      orientationVector: axes.orientationVector,
      orientationNameFront: axes.orientationNameFront,
      orientationNameBack: axes.orientationNameBack,
      orientationNameLeft: axes.orientationNameLeft,
      orientationNameRight: axes.orientationNameRight,
      orientationNameUp: axes.orientationNameUp,
      orientationNameDown: axes.orientationNameDown,
    }
  }
}
